module.exports = __webpack_public_path__ + "static/media/filter-people.46da932b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/filter-people.jpg
// module id = 1921
// module chunks = 0